import { ManagedPopUp } from "./types";
import { getPopUpPriority } from "components/PopUpManagerV2/helpers/getPopUpPriority";

export const PREFIX_V2 = "pop-up-manager-v2";

export const sortByPriorityAndOpenedAt = (stack: ManagedPopUp[]): void => {
	stack.sort((a, b) => {
		const pa = getPopUpPriority(a.variant);
		const pb = getPopUpPriority(b.variant);
		if (pa !== pb) {
			return pa - pb;
		}
		return a.openedAt - b.openedAt;
	});
};
